<div class="banner" role="banner" *ifScreenSize="screenType.Desktop">
  <div class="container d-flex flex-row align-items-center justify-content-between">
    <h1 class="text-white">{{ title }}</h1>

    <img src="assets/images/mytwins-rewards-logo.png" alt="" />
  </div>
</div>
